import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  ActiveInactiveBranch,
  createBranch,
  deleteBranch,
  getAllActiveBranch,
  getAllBranch,
  getBranchByID,
  BranchDetailsImageUpload,
  updateBranch,
} from "./services/branch.services";
import { IBranch, IBranchs } from "./branchModal";

const initialState: IBranchs = {
  loading: false,
  formloading: false,
  error: "",
  BranchID: null,
  BranchList: [],
  BranchDetail: {
    ID: null,
    Country: "",
    Address: "",
    Phone: "",
    Email: "",
    IsActive: 1,
  },
};

const branchesSlice = createSlice({
  name: "branches",
  initialState,
  reducers: {
    clearBranchDetails: (state) => {
      state.BranchDetail = initialState.BranchDetail;
    },
    setBranchID: (state, action) => {
      state.BranchID = action.payload;
    },
    clearBranchID: (state) => {
      state.BranchID = initialState.BranchID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllBranch.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllBranch.fulfilled,
      (state, action: PayloadAction<IBranch[]>) => {
        state.loading = false;
        state.BranchList = action.payload || [];
      }
    );
    builder.addCase(getAllBranch.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.BranchList = [];
    });
    builder.addCase(createBranch.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(createBranch.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createBranch.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateBranch.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateBranch.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateBranch.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteBranch.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteBranch.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteBranch.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getBranchByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getBranchByID.fulfilled, (state, action: any) => {
      state.loading = false;
      state.BranchDetail = action.payload;
    });
    builder.addCase(getBranchByID.rejected, (state, action) => {
      state.loading = false;
      state.BranchDetail = initialState.BranchDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveBranch.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveBranch.fulfilled,
      (state, action: PayloadAction<IBranch[]>) => {
        state.loading = false;
        state.BranchList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveBranch.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.BranchList = [];
    });
    builder.addCase(ActiveInactiveBranch.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveBranch.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveBranch.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // IMAGE UPLOAD
    builder.addCase(BranchDetailsImageUpload.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(BranchDetailsImageUpload.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(BranchDetailsImageUpload.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearBranchDetails, clearBranchID, setBranchID } =
  branchesSlice.actions;
export default branchesSlice.reducer;
